module.exports = __webpack_public_path__ + "logo.44bbe2a2.png";